function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.81,10.28c35.33-.39,661.65-.24,697-.4,5.27,0,18,2.21,19.15-4.94.83-5-6.76-7.09-7.59-2.09.18-1.11,2.57-.34,1.08-.92a5.54,5.54,0,0,0-1.41,0H698.77L376.56,2q-29.07.17-58.07.27c-6.4,0-308.29,0-314.69.11-5.06,0-5.07,7.92,0,7.87Z",
  transform: "translate(0 0.01)",
  fill: "#ff5100"
});

var SvgUnderlineFullWidth = function SvgUnderlineFullWidth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 720,
    height: 10.29,
    viewBox: "0 0 720 10.29",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUnderlineFullWidth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/underline-full-width.35da5cac.svg";
export { ForwardRef as ReactComponent };